<template>
  <div class="row mt-4 box-users">
    <div class="col-md-6 border-right mb-3">
      <h5>Usuarios de la empresa</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="search"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
        />
      </div>
    </div>
    <div class="col-md-6 border-right mb-3">
      <h5>Usuarios en la entidad</h5>
      <div class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="searchUsers"
          class="d-inline-block mr-1"
          placeholder="Filtrar..."
        />
      </div>
    </div>
    <div class="col-md-6 border-right">
      <vs-list class="box-users">
        <div v-for="user in filteredUsers" :key="user.id">
          <vs-list-item
            :class="{ exists: isUserInOption(user) }"
            :title="user.nombre"
            :subtitle="user.correo">
            <vs-button
              color="warning"
              v-if="!isUserInOption(user)"
              size="small"
              type="border"
              @click="addUser(user)"
            >
              Agregar
            </vs-button>
          </vs-list-item>
        </div>
      </vs-list>
    </div>
    <div class="col-md-6">
      <vs-list class="box-users">
        <div v-for="user in filteredUsersOnOption" :key="user.id">
          <vs-list-item :title="user.name" :subtitle="user.email">
            <vs-button
              color="danger"
              size="small"
              type="border"
              icon="highlight_off"
              @click="removeUser(user)"
            >
            </vs-button>
          </vs-list-item>
        </div>
      </vs-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [],
  props: {
    option: {
      type: Object,
      required: true
    },
    usersGeneral: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: '',
      searchUsers: '',
      usersOption: {
        ...this.option
      },
      usersOnOption: this.optionUsers
    };
  },
  watch: {
    option(newValue) {
      this.usersOption = { ...newValue };
    },
    optionUsers(newValue) {
      this.usersOnOption = newValue;
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersByGroup',
      'usersCompanyAssign'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Materials', [
      'optionUsers'
    ]),
    filteredUsers() {
      if (this.search !== '') {
        return this.usersGeneral
          .filter((user) => user.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
      }
      return this.usersGeneral;
    },
    filteredUsersOnOption() {
      if (this.searchUsers !== '') {
        return this.usersOnOption
          .filter((user) => user.nombre.toLowerCase().indexOf(this.searchUsers.toLowerCase()) > -1);
      }
      return this.usersOnOption;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'getUsersGroup',
      'addUserToGroup',
      'removeUserToGroup'
    ]),
    ...mapActions('Materials', [
      'getOptionUsers',
      'removeOptionUser',
      'addUserToOption'
    ]),
    isUserInOption(user) {
      return (this.optionUsers || []).find((userOption) => userOption.id === user.id);
    },
    removeUser(user) {
      this.removeOptionUser({
        id: this.usersOption.optionId,
        userId: user.id,
        user
      });
    },
    addUser(user) {
      const body = {
        optionId: this.usersOption.optionId,
        usuario: [user.id],
        usuarios: this.usersOnOption.map((userMap) => userMap.id),
        user: {
          id: user.id,
          optionId: this.usersOption.optionId,
          name: user.nombre,
          email: user.correo
        }
      };

      body.usuarios = body.usuarios.length
        ? body.usuarios.concat(`${user.id}`) : body.usuarios = [user.id];

      this.addUserToOption({ body });
    }
  },
  mounted() {
    this.usersOnOption = this.optionUsers;
  }
};
</script>

<style scoped>
.box-users {
  height: 500px;
  overflow-y: auto;
}
.exists {
  color: #671e85;
  background: #671e852b;
  border-radius: 4px;
  margin-top: 2px;
}
</style>
